<template>
  <div class="sm-timemachine">
    <div class="sm-timemachine-header">
      <div class="sm-timemachine-title">
        <r-text type="caption">
          Время
        </r-text>
      </div>
      <div class="sm-timemachine-current">
        <r-text type="caption">
          {{ formatTooltip(current) }}
        </r-text>
      </div>
      <div class="sm-timemachine-controls">
        <el-tooltip
          :open-delay="500"
          effect="dark"
          content="На шаг назад"
          placement="top"
        >
          <el-button
            class="r-button main sm-timemachine-controls-btn previous"
            size="mini"
            @click="goToStep('previous')"
            type="primary"
            icon="el-icon-arrow-left"
            :disabled="current === 0"
          />
        </el-tooltip>
        <el-tooltip
          :open-delay="500"
          effect="dark"
          content="Запустить с начала"
          placement="top"
        >
          <el-button
            class="r-button main sm-timemachine-controls-btn refresh"
            size="mini"
            @click="refreshPlaying"
            type="primary"
            icon="el-icon-refresh-left"
          />
        </el-tooltip>
        <el-tooltip
          :open-delay="500"
          effect="dark"
          :content="timemachinePlaying ? 'Остановить' : 'Запустить'"
          placement="top"
        >
          <el-button
            class="r-button main sm-timemachine-controls-btn play"
            size="mini"
            @click="playClickHandler"
            type="primary"
            :icon="
              timemachinePlaying ? 'el-icon-remove' : 'el-icon-caret-right'
            "
          />
        </el-tooltip>
        <el-tooltip
          :open-delay="500"
          effect="dark"
          content="На шаг вперед"
          placement="top"
        >
          <el-button
            class="r-button main sm-timemachine-controls-btn previous"
            size="mini"
            @click="goToStep('next')"
            type="primary"
            icon="el-icon-arrow-right"
            :disabled="current === times.length - 1"
          />
        </el-tooltip>
      </div>
    </div>
    <div class="sm-timemachine-container">
      <r-text type="caption" style="margin-right: 16px;">
        {{ formatTooltip(0) }}
      </r-text>
      <el-slider
        class="r-slider dark square"
        :min="0"
        :max="times.length - 1"
        :step="1"
        v-model="current"
        @change="changeTimeValue"
        :show-tooltip="false"
        :format-tooltip="formatTooltip"
      />
      <r-text type="caption" style="margin-left: 16px;">
        {{ formatTooltip(times.length - 1) }}
      </r-text>
    </div>
  </div>
</template>

<script>
import { secondsToTime } from "@/utils";

export default {
  data() {
    return {
      current: 0,
      interval: null,
      playingStep: 20
    };
  },
  computed: {
    times() {
      return this.$store.state.scenarioModelling.timeData;
    },
    timemachinePlaying() {
      return this.$store.state.scenarioModelling.timemachinePlaying;
    }
  },
  methods: {
    formatTooltip(value) {
      const { h, m, s } = secondsToTime(this.times[value]);

      return `${h}:${m}:${s}`;
    },
    changeTimeValue(index) {
      this.$store.commit("CHANGE_SM_CALC_PROP", {
        field: "activeTimeValue",
        value: this.times[index]
      });
    },
    playClickHandler() {
      if (this.timemachinePlaying) this.stop();
      else this.play();
    },
    play() {
      this.$store.commit("CHANGE_SM_CALC_PROP", {
        field: "timemachinePlaying",
        value: true
      });

      this.interval = setInterval(() => {
        const nextStep = this.current + this.playingStep;

        if (nextStep <= this.times.length - 1) {
          this.current += this.playingStep;
        } else {
          this.current = this.times.length - 1;
          this.stop();
        }

        this.changeTimeValue(this.current);
        this.$forceUpdate();
      }, 300);
    },
    refreshPlaying() {
      this.current = 0;

      if (this.timemachinePlaying) this.stop();
      this.changeTimeValue(this.current);
      this.play();
    },
    stop() {
      clearInterval(this.interval);
      this.$store.commit("CHANGE_SM_CALC_PROP", {
        field: "timemachinePlaying",
        value: false
      });
      this.interval = null;
    },
    goToStep(type) {
      switch (type) {
        case "next": {
          const nextStep = this.current + 1;

          if (nextStep <= this.times.length - 1) {
            this.current += 1;
          } else {
            this.current = this.times.length - 1;
          }
          break;
        }
        case "previous": {
          const previousStep = this.current - 1;

          if (previousStep <= this.times.length - 1) {
            this.current -= 1;
          } else {
            this.current = this.times.length - 1;
          }
        }
      }

      this.changeTimeValue(this.current);
    }
  },
  created() {
    const { activeTimeValue } = this.$store.state.scenarioModelling;

    this.current = this.times.findIndex(t => t === activeTimeValue);
  }
};
</script>

<style lang="scss">
.sm-timemachine {
  position: absolute;
  right: 16px;
  bottom: 32px;
  padding: 16px;
  z-index: 10;
  border-radius: 4px;
  border: 1px solid transparent;
  background-color: var(--bg_panel_primary) !important;
  border-color: var(--dividers_low_contrast) !important;
  color: var(--text_secondary) !important;
  width: 50vh;

  &-header {
    margin-bottom: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &-current {
    padding: 4px 12px;
    border-radius: 4px;
    background-color: var(--bg_surface) !important;
  }

  &-controls {
    display: flex;
    align-items: center;

    &-btn {
      color: var(--text_secondary) !important;
      background: transparent !important;
      border-color: transparent !important;
      padding: 0 !important;
      font-size: 18px !important;
      height: 24px !important;
      width: 24px !important;
      margin-left: 4px !important;

      &:hover {
        background-color: var(--bg_surface) !important;
      }
    }
  }

  &-container {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .r-slider {
      flex: 1;

      .el-slider {
        &__runway {
          height: 16px !important;
        }

        &__bar {
          height: 16px !important;
          background-color: rgba(var(--accent_primary), 0.3) !important;
        }

        &__button {
          height: 16px !important;
          border-radius: 2px !important;

          &-wrapper {
            top: -10px !important;
          }
        }
      }
    }
  }
}
</style>
